import axiosInstance, { URLS } from "../axios_instance";
import { ConsultationHistoryParams } from "./interfaces/video_https.interface";

const VIDEO_URI = URLS.VIDEO_URI;

export const getIncomingConsultations = () =>
  axiosInstance.get(`${VIDEO_URI}/consultation/doctor/incoming`);

export const getActiveConsultation = () =>
  axiosInstance.get(`${VIDEO_URI}/consultation/doctor/active`);

export const getConsultationById = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}`);

export const respondToConsultation = (consultationId: string, status: "accepted" | "rejected") =>
  axiosInstance.patch(`${VIDEO_URI}/consultation/${consultationId}/respond`, { status });

export const startConsultation = (consultationId: string) =>
  axiosInstance.patch(`${VIDEO_URI}/consultation/${consultationId}/start`);

export const completeConsultation = (consultationId: string, recordingUrl?: string) =>
  axiosInstance.patch(`${VIDEO_URI}/consultation/${consultationId}/complete`, {
    ...(recordingUrl ? { recording_url: recordingUrl } : {}),
  });

export const rejoinConsultation = (consultationId: string) =>
  axiosInstance.patch(`${VIDEO_URI}/consultation/${consultationId}/rejoin`);

export const saveClinicalNotes = (consultationId: string, payload: any) =>
  axiosInstance.post(`${VIDEO_URI}/consultation/${consultationId}/notes`, payload);

export const getClinicalNotes = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}/notes`);

export const savePrescription = (consultationId: string, payload: any) =>
  axiosInstance.post(`${VIDEO_URI}/consultation/${consultationId}/prescription`, payload);

export const saveUploadedPrescriptionUrl = (consultationId: string, prescriptionPdfUrl: string) =>
  axiosInstance.patch(`${VIDEO_URI}/consultation/${consultationId}/prescription/upload-url`, { prescription_pdf_url: prescriptionPdfUrl });

export const getPrescription = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}/prescription`);

export const getPrescriptionPdf = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}/prescription/pdf`);

export const getClinicalNotesPdf = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}/notes/file-url`);

export const getPatientInfo = (consultationId: string) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/${consultationId}/patient-info`);

export const shareConsultation = (consultationId: string, channels: string[]) =>
  axiosInstance.post(`${VIDEO_URI}/consultation/${consultationId}/prescription/share`, { channels });

export const getConsultationHistory = (params: ConsultationHistoryParams) =>
  axiosInstance.get(`${VIDEO_URI}/consultation/doctor/history`, { params });
